import React, { useContext, useEffect, useState } from "react";
import classes from "../ServicesTable.module.scss"
import { Col, Collapse, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useQuery } from "@tanstack/react-query";
import { E2Data } from "../../../lib/ddd/ddd";
import { OrgIdContext } from "../../../store/orgId_context";
import { useTranslation } from "react-i18next";
import DeviceTr from "./DeviceTr";
import DeviceForm from "./DeviceForm";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new E2Data("VP_DevicesOrgUnits");
ddd.format = "full";

const e2dataOrg = new E2Data("EU_AOrg");
e2dataOrg.format = "full";

const DevicesTable = ({refetchDevices}) => {
    const [descriptionCollapse, setDescriptionCollapse] = useState(false);
    const { integrationDevice, aboutOrgId, sessionInfo} = useContext(OrgIdContext);
    const [e2Data_EU_devices, setE2Data_EU_WorkflowSteps] = useState(E2Data.WithConnectionKey(apiRequestAddress, integrationDevice, "VP_DevicesOrgUnits").ApplyParams({filter:'OrgId="'+aboutOrgId+'" AND AssignedTo="CKT"', format:'full'}));
    const [payments_req] = useState(new  E2Data().ApplyParams({entity: "EU_SCR_PaymentType",filter:'CountryCodeSC__CountryCode ="'+sessionInfo?.Extended?.CountryCodeSC__CountryCode+'" OR CountryCodeSC__CountryCode = null', format:'full'}));
    const {t} = useTranslation();

    const {isPending, data, refetch} = useQuery({
        queryKey: ['Data.GetEntityData', e2Data_EU_devices.GetParamsObject()],
        queryFn: () => e2Data_EU_devices.GetData()
    })

    const {isPending: isInfoPending, data : info} = useQuery({
        queryKey: ['Data.GetEntityInfo', ddd.GetParamsObject()],
        queryFn: () => ddd.GetEntityInfo()
    })

    const {isPending : isPaymentsPending, data:payments} = useQuery({
        queryKey: ['Data.GetEntityData', payments_req.GetParamsObject()],
        queryFn: () => payments_req.GetData()
    })

    const {isPending:orgPending, data:orgData} = useQuery({
        queryKey: ['Data.GetEntityData', e2dataOrg.GetParamsObject()],
        queryFn: () => e2dataOrg.GetData(),
    })

    useEffect(() => {
        if(refetchDevices && refetchDevices > 0)
            refetch();
    }, [refetchDevices]);

    const onDataChanged = (newData) =>{
        refetch();
    }

    return (
    <>
      <div className={`mt-3 ${classes["container"]}`}>
            <Container fluid className={classes["titleContainer"]}> 
                <Row className="g-0">
                    {/* <Col className="col-1 border">{t("Active")}</Col>  */}
                    <Col className="col-7 border text-start ps-3">{t("Name")}</Col>
                    <Col className="col-1 border">{t("Production")}</Col>
                    <Col className="col-3 border">{t("Created")}</Col>
                    <Col className="col-1"></Col>
                </Row>
            </Container>
            {data?.result?.data?.map((device, index) => {
                return(<>
                    <DeviceTr key={device.Id} data={device} index={index} info={info} payments={payments?.result?.data} orgData={orgData?.result?.data?.[0]} onDataChanged={onDataChanged}/>
                    {/* <DeviceForm data={device} index={index} info={info} payments={payments?.result?.data} orgData={orgData?.result?.data?.[0]}/> */}
                </>)
            })}
            
      </div>
    </>
    );
};

export default DevicesTable;
